import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { Site } from "../../../../shared/entities/scripts/site";
import { Study } from "../../../../shared/entities/scripts/study";
import { DoArraysOverlap } from "../../../../shared/scripts/array-functions";
import { FilterOption } from "../../../../shared/scripts/filtering/filtering.entities";
import { ResetDropdownFilters } from "../../../../shared/scripts/filtering/filtering.utilities";
import { Outcome } from "../components/outcomes-tab/scripts/outcomes.entities";
import { Visit } from "../components/visits-tab/scripts/visits.entities";
import { Assessment } from "../components/assessments-tab/scripts/assessments.entities";
import { Samples } from "../components/samples-tab/scripts/samples.entities";
import { AssessmentLookup } from "../components/assessments-tab/scripts/assessments.lookup"
import { Intervention } from "../components/interventions-tab/scripts/interventions.entities";
export interface IFilteringParent {
    FilterUpdated();
}

export class FilterSection {

    parent: IFilteringParent;

    studies: Study[] = [];
    appendices: Appendix[] = [];
    sites: Site[] = [];
    visits: Visit[] = [];
    visitRequired: FilterOption[] = [];
    outcomes: Outcome[] = [];
    assessments: Assessment[] = [];
    timepoints: Assessment[] = [];
    samples: Samples[] = [];
    samplesTimepoints: Samples[] = [];
    interventions: Intervention[] = [];

    allStudyIds: number[] = []; activeStudyIds: number[] = []; selectedStudyIds: number[] = [];
    allAppendixIds: number[] = []; activeAppendixIds: number[] = []; selectedAppendixIds: number[] = [];
    allSiteIds: number[] = []; activeSiteIds: number[] = []; selectedSiteIds: number[] = [];
    allVisitIds: number[] = []; activeVisitIds: number[] = []; selectedVisitIds: number[] = [];
    allVisitRequiredIds: number[] = []; activeVisitRequiredIds: number[] = []; selectedVisitRequiredIds: number[] = [];
    allOutcomeIds: number[] = []; activeOutcomeIds: number[] = []; selectedOutcomeIds: number[] = [];
    allAssessmentIds: number[] = []; activeAssessmentIds: number[] = []; selectedAssessmentIds: number[] = [];
    allTimepointIds: number[] = []; activeTimepointIds: number[] = []; selectedTimepointIds: number[] = [];
    allSamplesIds: number[] = []; activeSamplesIds: number[] = []; selectedSamplesIds: number[] = [];
    allSamplesTimepointsIds: number[] = []; activeSamplesTimepointsIds: number[] = []; selectedSamplesTimepointsIds: number[] = [];

    studySelectId: string = "#study-dropdown";
    appendixSelectId: string = "#appendix-dropdown";
    siteSelectId: string = "#site-dropdown";
    visitSelectId: string = "#visit-dropdown";
    visitRequiredSelectId: string = "#visit-required-dropdown";
    outcomeSelectId: string = "#outcome-dropdown";
    assessmentSelectId: string = "#assessment-dropdown";
    timepointSelectId: string = "#timepoint-dropdown";
    samplesSelectId: string = "#samples-dropdown";
    samplesTimepointsSelectId: string = "#samples-timepoint-dropdown";

    constructor(studies: Study[], appendices: Appendix[], sites: Site[], visits: Visit[], visitRequired: FilterOption[], outcomes: Outcome[], assessments: Assessment[], timepoints: Assessment[], samples: Samples[], samplesTimepoints: Samples[], interventions: Intervention[], parent: IFilteringParent) {

        this.parent = parent;

        this.studies = studies;
        this.appendices = appendices;
        this.sites = sites;
        this.visits = visits;
        this.visitRequired = visitRequired;
        this.outcomes = outcomes;       
        this.interventions = interventions;
        Study.SortByName(this.studies);
        Appendix.SortByName(this.appendices);

        this.allStudyIds = this.studies.map((s: Study) => s.Id);
        this.allAppendixIds = this.appendices.map((a: Appendix) => a.Id);
        this.allSiteIds = this.sites.map((s: Site) => s.Id);
        this.allVisitIds = this.visits.map((v: Visit) => v.Id);
        this.allVisitRequiredIds = this.visitRequired.map((v: FilterOption) => v.Id);
        this.allOutcomeIds = this.outcomes.map((o: Outcome) => o.Id);
        this.allAssessmentIds = this.assessments.map((a: Assessment) => a.Id);
        this.allTimepointIds = this.timepoints.map((t: Assessment) => t.Id);
        this.allSamplesIds = this.samples.map((s: Samples) => s.Id);
        this.allSamplesTimepointsIds = this.samplesTimepoints.map((st: Samples) => st.Id);

        this.initializeFilters();
        this.resetFilters();
    }

    initializeFilters(): void {
        this.setupDropdown("study", this.studySelectId, "Platforms");
        this.setupDropdown("appendix", this.appendixSelectId, "Trials");
        this.setupDropdown("site", this.siteSelectId, "Sites");
        this.setupDropdown("visit", this.visitSelectId, "");
        this.setupDropdown("visit-required", this.visitRequiredSelectId, "");
        this.setupDropdown("outcome", this.outcomeSelectId, "");
        this.setupDropdown("assessment", this.assessmentSelectId, "");
        this.setupDropdown("timepoint", this.timepointSelectId, "");
        this.setupDropdown("samples", this.samplesSelectId, "");
        this.setupDropdown("samples-timepoints", this.samplesTimepointsSelectId, "");
    }

    setupDropdown(type: string, elementId: string, optionName: string): void {

        $(elementId).selectpicker({
            dropupAuto: false,
            selectedTextFormat: "count",

            countSelectedText: (numSelected, numTotal) => {

                let activeCount: number = 0;
                if (type == 'study') activeCount = this.activeStudyIds.length;
                else if (type == 'appendix') activeCount = this.activeAppendixIds.length;
                else if (type == 'site') activeCount = this.activeSiteIds.length;
                else if (type == 'visit') activeCount = this.activeVisitIds.length;
                else if (type == 'visit-required') activeCount = this.activeVisitRequiredIds.length;
                else if (type == 'outcome') activeCount = this.activeOutcomeIds.length;
                else if (type == 'assessment') activeCount = this.activeAssessmentIds.length;
                else if (type == 'timepoint') activeCount = this.activeTimepointIds.length;
                else if (type == 'samples') activeCount = this.activeSamplesIds.length;
                else if (type == 'samples-timepoints') activeCount = this.activeSamplesTimepointsIds.length;
                if (numSelected == numTotal) {
                    return "All " + optionName + "   (n = " + numSelected + ")";
                }
                else {
                    return numSelected + " of " + activeCount + " " + optionName + " Selected";
                }
            }
        });
        $(elementId).selectpicker("refresh");

        $(elementId).on('changed.bs.select', (e, clickedIndex, isSelected, previousValue) => {
            let values: string[] = <string[]>($(elementId).val());
            this.filterDropdownOptions(type, values.map(i => Number(i)));
            $(elementId).selectpicker("refresh");
            this.filterUpdated(this.selectedStudyIds, this.selectedAppendixIds, this.selectedSiteIds, this.selectedVisitIds, this.selectedVisitRequiredIds, this.selectedOutcomeIds, this.selectedAssessmentIds, this.selectedTimepointIds, this.selectedSamplesIds, this.selectedSamplesTimepointsIds);
        });
    }

    setDropdownOptions(type: string, elementId: string, selectedElementIds: number[], activeElementIds: number[], allElements: any[], optionParameterValue: string, optionParameterName: string): void {

        $(elementId).empty();

        allElements.forEach((element: any) => {
            let selected: boolean = false;
            let disabled: boolean = false;

            if (selectedElementIds.includes(element[optionParameterValue])) {
                selected = true;
            }

            if (!activeElementIds.includes(element[optionParameterValue])) {
                disabled = true;
                selected = false;
            }

            if (!disabled) {
                let option: any = new Option(element[optionParameterName], element[optionParameterValue], false, selected);
                //option.disabled = disabled;
                $(elementId).append(option);
            }
        });
        $(elementId).selectpicker("refresh");
    }

    resetFilters(): void {
        this.selectedStudyIds = this.activeStudyIds = this.allStudyIds;
        this.selectedAppendixIds = this.activeAppendixIds = this.allAppendixIds;
        this.selectedSiteIds = this.activeSiteIds = this.allSiteIds;
        this.selectedVisitIds = this.activeVisitIds = this.allVisitIds;
        this.selectedVisitRequiredIds = this.activeVisitRequiredIds = this.allVisitRequiredIds;
        this.selectedOutcomeIds = this.activeOutcomeIds = this.allOutcomeIds;
        this.selectedAssessmentIds = this.activeAssessmentIds = this.allAssessmentIds;
        this.selectedTimepointIds = this.activeTimepointIds = this.allTimepointIds;
        this.selectedSamplesIds = this.activeSamplesIds = this.allSamplesIds;
        this.selectedSamplesTimepointsIds = this.activeSamplesTimepointsIds = this.allSamplesTimepointsIds;
        this.setDropdownOptions("study", this.studySelectId, this.selectedStudyIds, this.allStudyIds, this.studies, "Id", "Name");
        this.filterDropdownOptions("study", this.selectedStudyIds);

        ResetDropdownFilters([this.studySelectId, this.appendixSelectId, this.siteSelectId, this.visitSelectId, this.visitRequiredSelectId, this.outcomeSelectId, this.assessmentSelectId, this.timepointSelectId, this.samplesSelectId, this.samplesTimepointsSelectId]);

        this.filterUpdated(this.activeStudyIds, this.activeAppendixIds, this.activeSiteIds, this.activeVisitIds, this.activeVisitRequiredIds, this.activeOutcomeIds, this.activeAssessmentIds, this.activeTimepointIds, this.activeSamplesIds, this.activeSamplesTimepointsIds);
    }

    filterDropdownOptions(type: string, currentValues: number[]) {

        //console.log(type, currentValues);

        if (type == 'study') {
            this.selectedStudyIds = currentValues;
            this.activeAppendixIds = this.appendices.map((a: Appendix) => {
                if (this.selectedStudyIds.includes(a.StudyId)) return a.Id;
            }).filter((id: number) => id != undefined);
            this.activeSiteIds = this.sites.map((s: Site) => {
                if (DoArraysOverlap(this.selectedStudyIds, s.StudyIds)) return s.Id;
            }).filter((id: number) => id != undefined);

            //cohort selection activates all hubs/sites
            this.selectedAppendixIds = this.activeAppendixIds;
            this.selectedSiteIds = this.activeSiteIds;
        }
        else if (type == 'appendix') {
            this.selectedAppendixIds = currentValues;
        }
        else if (type == 'site') {
            //no filtering "left" to study or appendix based on selected sites
            this.selectedSiteIds = currentValues;
        }
        else if (type == "visit") {
            this.selectedVisitIds = currentValues;
        }
        else if (type == "visit-required") {
            this.selectedVisitRequiredIds = currentValues;
        }
        else if (type == "outcome") {
            this.selectedOutcomeIds = currentValues;
        }
        else if (type == "assessment") {
            this.selectedAssessmentIds = currentValues;
        }
        else if (type == "timepoint") {
            this.selectedTimepointIds = currentValues;
        }
        else if (type == "samples") {
            this.selectedSamplesIds = currentValues;
        }
        else if (type == "samples-timepoints") {
            this.selectedSamplesTimepointsIds = currentValues;
        }

        if (type != 'study') this.setDropdownOptions("study", this.studySelectId, this.selectedStudyIds, this.allStudyIds, this.studies, "Id", "Name");
        if (type != 'appendix') this.setDropdownOptions("appendix", this.appendixSelectId, this.activeAppendixIds, this.activeAppendixIds, this.appendices, "Id", "Name");
        if (type != 'site') this.setDropdownOptions("site", this.siteSelectId, this.activeSiteIds, this.activeSiteIds, this.sites, "Id", "Name");
        if (type != 'visit') this.setDropdownOptions("visit", this.visitSelectId, this.selectedVisitIds, this.activeVisitIds, this.visits, "Id", "Name");
        if (type != 'visit-required') this.setDropdownOptions("visit-required", this.visitRequiredSelectId, this.selectedVisitRequiredIds, this.activeVisitRequiredIds, this.visitRequired, "Id", "Name");
        if (type != 'outcome') this.setDropdownOptions("outcome", this.outcomeSelectId, this.selectedOutcomeIds, this.activeOutcomeIds, this.outcomes, "Id", "Name");
        if (type != 'assessment') this.setDropdownOptions("assessment", this.assessmentSelectId, this.selectedAssessmentIds, this.activeAssessmentIds, this.assessments, "Id", "Name");
        if (type != 'timepoint') this.setDropdownOptions("timepoint", this.timepointSelectId, this.selectedTimepointIds, this.activeTimepointIds, this.timepoints, "Id", "Name");
        if (type != 'samples') this.setDropdownOptions("samples", this.samplesSelectId, this.selectedSamplesIds, this.activeSamplesIds, this.samples, "Id", "Name");
        if (type != 'samples-timepoints') this.setDropdownOptions("samples-timepoints", this.samplesTimepointsSelectId, this.selectedSamplesTimepointsIds, this.activeSamplesTimepointsIds, this.samplesTimepoints, "Id", "Name");
    }

    filterUpdated(studyIds: number[], appendixIds: number[], siteIds: number[], visitIds: number[], visitRequiredIds: number[], outcomeIds: number[], assessmentIds: number[], timepointIds: number[], samples: number[], samplesTimepoints: number[]): void {
        //console.log("Current filter values:", {
        //    studyIds, appendixIds, siteIds, visitIds, samples, samplesTimepoints
        //})
        //add "0" entry to signify all selected
        //if (this.selectedStudyIds.length == this.activeStudyIds.length) this.selectedStudyIds = [0].concat(studyIds);
        //if (this.selectedAppendixIds.length == this.activeAppendixIds.length) this.selectedAppendixIds = [0].concat(appendixIds);
        //if (this.selectedSiteIds.length == this.activeSiteIds.length) this.selectedSiteIds = [0].concat(siteIds);
        //if (this.selectedVisitIds.length == this.activeVisitIds.length) this.selectedVisitIds = [0].concat(visitIds);
        //this.parent.FilterUpdated(studyIds, appendixIds, siteIds, visitIds);
        this.parent.FilterUpdated();
    }

    refreshFilters(): void {
        this.filterUpdated(this.selectedStudyIds, this.selectedAppendixIds, this.selectedSiteIds, this.selectedVisitIds, this.selectedVisitRequiredIds, this.selectedOutcomeIds, this.selectedAssessmentIds, this.selectedTimepointIds, this.selectedSamplesIds, this.selectedSamplesTimepointsIds);
    }

    refreshOutcomesFilters(outcomes: Outcome[]): void {
        this.outcomes = outcomes;
        this.allOutcomeIds = this.outcomes.map((o: Outcome) => o.Id);
        this.selectedOutcomeIds = this.activeOutcomeIds = this.allOutcomeIds;
        this.filterDropdownOptions("study", this.selectedStudyIds);
        this.refreshFilters();
    }

    refreshAssessmentsFilters(assessments: Assessment[], timepoints: Assessment[]) {
        this.assessments = assessments.sort((a, b) =>
            AssessmentLookup.GetAssessmentOrdering(a.Id) - AssessmentLookup.GetAssessmentOrdering(b.Id)
        );
        this.timepoints = timepoints;
        this.allAssessmentIds = this.assessments.map((a: Assessment) => a.Id);
        this.allTimepointIds = this.timepoints.map((t: Assessment) => t.Id);
        this.selectedAssessmentIds = this.activeAssessmentIds = this.allAssessmentIds;
        this.selectedTimepointIds = this.activeTimepointIds = this.allTimepointIds;
        this.filterDropdownOptions("study", this.selectedStudyIds);
        this.refreshFilters();
    }

    refreshSamplesFilters(samples: Samples[], samplesTimepoints: Samples[]) {
        this.samples = samples;
        this.samplesTimepoints = samplesTimepoints;
        this.allSamplesIds = this.samples.map((s: Samples) => s.Id);
        this.allSamplesTimepointsIds = this.samplesTimepoints.map((st: Samples) => st.Id);
        this.selectedSamplesIds = this.activeSamplesIds = this.allSamplesIds;
        this.selectedSamplesTimepointsIds = this.activeSamplesTimepointsIds = this.allSamplesTimepointsIds;
        this.filterDropdownOptions("study", this.selectedStudyIds);
        this.refreshFilters();
    }

    refreshInterventionsFilters(interventions: Intervention[]): void {
        this.interventions = interventions;
        this.filterDropdownOptions("study", this.selectedStudyIds);
        this.refreshFilters();
    }
}